/**
 * Sprint Redesign v1 (Do 03.09.2026) — Feature-Flag.
 *
 * Zentrale Prüfung, ob das Redesign-v1-UI aktiv ist.
 * ENV: REACT_APP_REDESIGN_V2=true → neues Routing/Sidebar/TopBar aktiv.
 * false / unset → Fallback auf Phase-4-Stand (Rollback-safe).
 *
 * Sprint-Backlog Redesign v1 · Do 03.09.2026 13:30 · Andreas-Freigabe.
 */
export const REDESIGN_V2_ENABLED =
  (process.env.REACT_APP_REDESIGN_V2 || "").toLowerCase() === "true";
